import React from 'react';
import parse from 'html-react-parser';
import './TabNotificationRow.scss';
import { Typography } from 'antd';
import { Map, Placemark, YMaps } from 'react-yandex-maps';
import { Appeal } from '../../model/Appeal';
import { formatDateTime } from '../../utils/formatter';
import Constants from '../../constants/constants';
import { File } from '../../model/File';
import DocumentBox from '../InfoLabel/DocumentBox/DocumentBox';

interface TabNotificationProps {
  appeal: Appeal;
}

const TabNotificationRow = (props: TabNotificationProps): JSX.Element => {
  return (
    <>
      {props.appeal.author && (
        <div className="tabNotificationRow">
          <Typography.Paragraph className="tabNotificationRow__title">
            Автор:
          </Typography.Paragraph>
          <div className="tabNotificationRow__text">
            {props.appeal.author.lastName ? props.appeal.author.lastName : ''}{' '}
            {props.appeal.author.firstName ? props.appeal.author.firstName : ''}{' '}
            {props.appeal.author.middleName
              ? props.appeal.author.middleName
              : ''}
          </div>
        </div>
      )}

      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Адресат:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">
          {props.appeal.municipalityName}
        </div>
      </div>

      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Тематика обращения:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">
          {props.appeal.categoryName}
        </div>
      </div>

      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Текст сообщения:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">
          {parse(props.appeal.description)}
        </div>
      </div>

      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Сообщение создано:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">
          {formatDateTime(props.appeal.createdAt)}
        </div>
      </div>
      {props.appeal?.files?.length > 0 && (
        <div className="tabNotificationRow">
          <Typography.Paragraph className="tabNotificationRow__title">
            Прикреплённые документы:
          </Typography.Paragraph>
          <div className="tabNotificationRow__files">
            {props.appeal.files.map((file: File) => {
              return <DocumentBox file={file} key={file.id} />;
            })}
          </div>
        </div>
      )}
      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Адрес:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">{props.appeal.address}</div>
      </div>

      <div className="tabNotificationRow">
        {/*<Typography.Paragraph className="tabNotificationRow__title"></Typography.Paragraph>*/}
        <div className="tabNotificationRow__text">
          <div className="tabNotificationRow__map">
            <YMaps>
              <Map
                width="100%"
                height="100%"
                state={{
                  center: [props.appeal.latitude, props.appeal.longitude],
                  zoom: Constants.mapZoomAppeal,
                  behaviors: ["disable('scrollZoom')"],
                }}
                options={{
                  preset:
                    props.appeal.status.code === Constants.statusCodeConfirm
                      ? 'islands#greenIcon'
                      : 'islands#blueIcon',
                }}
              >
                <Placemark
                  geometry={[props.appeal.latitude, props.appeal.longitude]}
                  options={{ draggable: false }}
                />
              </Map>
            </YMaps>
          </div>
        </div>
      </div>
    </>
  );
};

export default TabNotificationRow;
